/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfRegistrationSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateRegistrationCommand, type CreateRegistrationCommand, type PaginatedListOfRegistrationSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ExportRequestBuilderNavigationMetadata, ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { RegistrationsItemRequestBuilderNavigationMetadata, RegistrationsItemRequestBuilderRequestsMetadata, type RegistrationsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /registrations
 */
export interface RegistrationsRequestBuilder extends BaseRequestBuilder<RegistrationsRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * Gets an item from the ApiSdk.registrations.item collection
     * @param id Unique identifier of the item
     * @returns {RegistrationsItemRequestBuilder}
     */
     byId(id: Guid) : RegistrationsItemRequestBuilder;
    /**
     * GetRegistrations
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfRegistrationSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<RegistrationsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfRegistrationSummary | undefined>;
    /**
     * CreateRegistration
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateRegistrationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetRegistrations
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RegistrationsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateRegistration
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateRegistrationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetRegistrations
 */
export interface RegistrationsRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const RegistrationsRequestBuilderUriTemplate = "{+baseurl}/registrations{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const RegistrationsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RegistrationsRequestBuilderNavigationMetadata: Record<Exclude<keyof RegistrationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: RegistrationsItemRequestBuilderRequestsMetadata,
        navigationMetadata: RegistrationsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
        navigationMetadata: ExportRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const RegistrationsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RegistrationsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfRegistrationSummaryFromDiscriminatorValue,
        queryParametersMapper: RegistrationsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: RegistrationsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateRegistrationCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
